import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

export default function SuccessDialog({
  successPopUp,
  setSuccessPopUp,
}) {
  return (
    <Dialog open={successPopUp} onClose={() => setSuccessPopUp(false)}>
      <DialogTitle>
        <Typography
          variant='h4'
          align='center'
          style={{ fontFamily: 'Lato, sans-serif', fontWeight: 'bold' }}
        >
          Set Reminder
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            color: 'var(--clr-theme-gray)',
            fontFamily: 'Karla',
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          Your reminder has been sent successfully!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='success'
          onClick={() => setSuccessPopUp(false)}
          sx={{
            backgroundColor: '#9291f0',
            textTransform: 'capitalize',
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.2rem',
            width: '100%',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
} 